<template>
  <v-date-picker
    mode="range"
    :popover="{ placement: placement, visibility: 'click' }"
    :columns="calendarLayout.columns"
    :rows="calendarLayout.rows"
    :is-expanded="calendarLayout.isExpanded"
    v-model="selectedDate"
    :locale="locale"
    :input-props="{
      placeholder: $t('components.core.date-range-calendar.placeholder')
    }"
  ></v-date-picker>
</template>

<script>
export default {
  data () {
    return {
      selectedDate: {
        start: new Date(this.start),
        end: new Date(this.end)
      }
    }
  },
  props: {
    placement: {
      default: 'bottom',
      type: String,
      required: false
    },
    locale: {
      default: undefined,
      type: String,
      required: false
    },
    start: {
      default: '',
      type: String,
      required: false
    },
    end: {
      default: '',
      type: String,
      required: false
    }
  },
  computed: {
    calendarLayout () {
      return this.$screens({
        // Default layout for mobile
        default: {
          columns: 1,
          rows: 1,
          isExpanded: true
        },
        // Override for large screens
        lg: {
          columns: 2,
          rows: 2,
          isExpanded: false
        }
      })
    }
  },
  watch: {
    'selectedDate.start' (val) {
      let day = String(val.getDate()).padStart(2, '0')
      let month = String(val.getMonth() + 1).padStart(2, '0')
      let year = val.getFullYear()
      this.$emit('update:start', year + '-' + month + '-' + day)
    },
    'selectedDate.end' (val) {
      let day = String(val.getDate()).padStart(2, '0')
      let month = String(val.getMonth() + 1).padStart(2, '0')
      let year = val.getFullYear()
      this.$emit('update:end', year + '-' + month + '-' + day)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/DateRangeCalendar.vue